import { z } from 'zod';
import {
  norwegianRegistrationNumber,
  swedishRegistrationNumber,
} from '../../../../utils/zod-schemas/registrationNumber';
import { vin } from '../../../../utils/zod-schemas/vinNumber';

export const registrationNumber = z.discriminatedUnion('marketCode', [
  z.object({ marketCode: z.literal('SE'), registrationNumber: swedishRegistrationNumber }),
  z.object({ marketCode: z.literal('NO'), registrationNumber: norwegianRegistrationNumber }),
  z.object({ marketCode: z.literal('US'), registrationNumber: vin }),
]);

export const registrationOrVinNumber = z.discriminatedUnion('marketCode', [
  z.object({
    marketCode: z.literal('SE'),
    registrationNumber: z.union([swedishRegistrationNumber, vin]),
  }),
  z.object({
    marketCode: z.literal('NO'),
    registrationNumber: z.union([norwegianRegistrationNumber, vin]),
  }),
  z.object({ marketCode: z.literal('US'), registrationNumber: vin }),
]);

export const virtualVehicleId = z.string().uuid();

export const hasDetails = z.boolean().refine((hasDetails) => hasDetails === true, {
  message: 'vehicleLookupError',
});

export const odometerReadingValue = z
  .number({ message: 'odometerReadingError' })
  .min(0, { message: 'odometerReadingError' });
export const odometerReadingUnit = z.enum(['km', 'mil']);
export const availableFrom = z.date({ message: 'availableFromError' });
export const deliveryTime = z
  .object({
    from: z.number({ message: 'availabilityError' }).min(0, { message: 'availabilityError' }),
    to: z.number({ message: 'availabilityError' }).min(0, { message: 'availabilityError' }),
  })
  .refine((deliveryTime) => deliveryTime.from < deliveryTime.to, {
    message: 'deliveryTimeError',
  });
export const deliveryUnit = z.enum(['day', 'week', 'month']);
export const purchaseType = z.string().optional();
export const applyProcess = z.string().optional();
